import { StandardAddress, MedusaAddress, StripeBillingDetails, StripeAddress } from '../generated/types/api';

// NOTE: Some of the fields cannot be empty, and must be set to `undefined`,
// which is the reason we are so verbose here.
export const medusaAddressFromStandardAddress = (address: Partial<StandardAddress>): MedusaAddress => ({
  first_name: address.first_name || '',
  last_name: address.last_name || '',
  address_1: address.line1 || '',
  address_2: address.line2 || undefined,
  province: address.state || '',
  country_code: address.country || '',
  metadata: address.metadata || {},
  company: address.company || undefined,
  phone: address.phone || undefined,
  city: address.city || '',
  postal_code: address.postal_code || ''
});

export const medusaAddressFromStripeBillingDetails = ({
  name,
  phone,
  address
}: Partial<StripeBillingDetails>): MedusaAddress => {
  const [first_name, last_name] = name.split(' ');

  return {
    first_name,
    last_name,
    phone,
    address_1: address.line1,
    address_2: address.line2,
    city: address.city,
    province: address.state,
    postal_code: address.postal_code,
    country_code: address.country.toLowerCase(),
    company: '',
    metadata: {}
  };
};

export const standardAddressFromMedusaAddress = (address: Partial<MedusaAddress>): StandardAddress => ({
  id: address.id || null,
  customer_id: address.customer_id || null,
  first_name: address.first_name,
  last_name: address.last_name,
  line1: address.address_1,
  line2: address.address_2,
  city: address.city,
  state: address.province,
  postal_code: address.postal_code,
  country: address.country_code,
  company: address.company,
  phone: address.phone,
  metadata: address.metadata
});

export const stripeAddressFromStandardAddress = (address: Partial<StandardAddress>): StripeAddress => ({
  line1: address.line1,
  line2: address.line2,
  city: address.city,
  state: address.state,
  postal_code: address.postal_code,
  country: address.country.toUpperCase()
});

export const stripeBillingDetailsFromStandardAddress = ({
  first_name,
  last_name,
  phone,
  email,
  ...address
}: Partial<StandardAddress>): StripeBillingDetails => ({
  name: `${first_name} ${last_name}`,
  phone: phone,
  email: email,
  address: stripeAddressFromStandardAddress(address)
});

export const standardAddressFromStripeBillingDetails = ({
  name,
  phone,
  email,
  address
}: Partial<StripeBillingDetails>): Omit<StandardAddress, 'id'> => ({
  first_name: name.split(' ')[0],
  last_name: name.split(' ')[1],
  phone,
  email,
  line1: address.line1,
  line2: address.line2,
  city: address.city,
  state: address.state,
  postal_code: address.postal_code,
  country: address.country.toLowerCase()
});

export const formatInlineAddress = ({
  first_name,
  last_name,
  line1,
  line2,
  city,
  state,
  postal_code
}: Omit<StandardAddress, 'id'>) =>
  `${first_name} ${last_name}, ${line1}${line2 ? `, ${line2}` : ''}, ${city}, ${state} ${postal_code}`;
